/**
 * Вход без ключа: ссылки с `?k=` нет, или деплой ключ не знает.
 *
 * Экран, а не пустая страница с ошибкой в консоли. До 11 сентября 2026 отказ
 * `resolveLearner` летел из подписки `diagnostic.current` через рендер React
 * и гасил приложение целиком: человек видел белый лист, а причина оставалась
 * в консоли — там, куда пятнадцатилетний не полезет и где «Server Error»
 * всё равно ничего бы не объяснило.
 *
 * Кнопок нет намеренно. Ключ не восстанавливается из браузера: единственный
 * путь обратно — ссылка от взрослого, `make key`.
 */
export function NoKey({ reason }: { reason: "missing" | "unknown" }) {
  return (
    <div className="cols cols--solo">
      <div className="col">
        <div className="eyebrow">Вход</div>
        <h1 className="h1">{reason === "missing" ? "Ссылка без ключа" : "Ключ не подошёл"}</h1>
        <p className="lede">
          {reason === "missing"
            ? "Система открывается личной ссылкой — той, где есть «?k=». Этот браузер ключа не помнит: либо страницу здесь ещё не открывали, либо чистили данные сайта."
            : "Ключ в этом браузере есть, но деплой его не знает: он от другого деплоя или база пересоздавалась."}
        </p>

        <div className="card">
          <div className="card__label">Что делать</div>
          <p style={{ margin: "12px 0 0", fontSize: 15, lineHeight: 1.5 }}>
            Открыть систему по своей ссылке. Она у взрослого: команда{" "}
            {/* Моноширинный набор без класса `.num`: это команда, а не число. */}
            <span style={{ fontFamily: "var(--mono)", fontSize: 14 }}>make key</span> печатает
            её целиком.
          </p>
          <p className="muted" style={{ marginTop: 10 }}>
            История занятий никуда не делась — она привязана к ключу, а не к браузеру.
          </p>
        </div>
      </div>
    </div>
  );
}
